var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};

export default isUndefined;